import { render, staticRenderFns } from "./BindOperatorDialog.vue?vue&type=template&id=3b47d896&scoped=true&"
import script from "./BindOperatorDialog.vue?vue&type=script&lang=js&"
export * from "./BindOperatorDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b47d896",
  null
  
)

export default component.exports